import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

function MemberJoinArea({ notMemberText, descriptionText, simpleJoinText }) {
  return (
    <Licensefull sx={{ background: `url(/images/guide/bottom_bg.png) no-repeat bottom center`, alignItems: 'center' }}>
      <h2>{notMemberText}</h2>
      <p style={{ fontSize: '1.2rem', marginTop: '10px' }}>{descriptionText}</p>
      <DownloadButton href="/login" sx={{ backgroundColor: '#4E45F5', color: '#fff', border: 'none' }}>
        {simpleJoinText}
      </DownloadButton>
    </Licensefull>
  );
}

const Licensefull = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'Column',
  margin: '0 auto',
  background:
    'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)), linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
  textAlign: 'center',
  padding: theme.spacing(7, 0),
  color: '#fff',
}));

const DownloadButton = styled(Button)({
  marginTop: '40px',
  fontSize: '1.2rem',
  fontWeight: 500,
  fontFamily: 'Pretendard-Regular',
  padding: '1rem 4rem',
});

export default MemberJoinArea;
